export function getFacetSearchSetInitialState() {
    return {};
}
